import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { showLoader, hideLoader } from "../redux/actions/LoaderActions"
import ApiServices from "../config/ApiServices"
import { toast } from "react-toastify"
import Loader from "../utils/Loader"
import { Bar, Pie } from "react-chartjs-2"
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend, ArcElement } from 'chart.js';
import BatchGraph from "../graphs/BatchGraph"
import { Link } from "react-router-dom"

ChartJS.register(
    BarElement,
    CategoryScale,
    LinearScale,
    Title,
    Tooltip,
    Legend,
    ArcElement
);

export default function TrainerDashboard(){
    const loading=useSelector((state)=>state.loader.loading)
    const dispatch=useDispatch()
    const [data,setData]=useState({})
    const trainerId=sessionStorage.getItem("userId")
    useEffect(()=>{
        dispatch(showLoader())
        ApiServices.apiRequest("trainerDashboard",{trainerId:trainerId})
        .then((res) => {
            if (res.data.success) {
                setData(res.data);
                console.log("trainer dashboard data is:",data)
            } else {
                toast.error(res.data.message);
            }
        })
        .catch((err) => {
            toast.error(err?.message ? err?.message : "Something went wrong");
        })
        .finally(() => {
            dispatch(hideLoader());
        });
    },[])

    return(
     <>
        <div className="container">
          <div className="page-inner">
          {loading ? (
                <Loader />
            ) : (
            <>
                <div className="d-flex align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
                <div>
                    <h3 className="fw-bold mb-3">Dashboard</h3>
                </div>
                <div className="ms-md-auto py-2 py-md-0">
                    <Link to={"/trainer/batches"} className="btn btn-label-info btn-round me-2">
                    Manage Batch
                    </Link>
                   
                </div>
                </div>
               <div className="row">
                    {/* Total Batches */}
                    <div className="col-sm-6 col-md-4">
                        <div className="card card-stats card-round">
                        <div className="card-body">
                            <div className="row align-items-center">
                            <div className="col-icon">
                                <div className="icon-big text-center icon-primary bubble-shadow-small">
                                <i className="fas fa-layer-group" /> 
                                </div>
                            </div>
                            <div className="col col-stats ms-3 ms-sm-0">
                                <div className="numbers">
                                <p className="card-category">Batches</p>
                                <h4 className="card-title">{data?.totalBatches}</h4>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>

                    {/* Active Batches */}
                    <div className="col-sm-6 col-md-4">
                        <div className="card card-stats card-round">
                        <div className="card-body">
                            <div className="row align-items-center">
                            <div className="col-icon">
                                <div className="icon-big text-center icon-success bubble-shadow-small">
                                <i className="fas fa-check-circle" /> 
                                </div>
                            </div>
                            <div className="col col-stats ms-3 ms-sm-0">
                                <div className="numbers">
                                <p className="card-category">Active Batches</p>
                                <h4 className="card-title">{data?.activeBatches}</h4>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>

                {/* Inactive Batches */}
                <div className="col-sm-6 col-md-4">
                    <div className="card card-stats card-round">
                    <div className="card-body">
                        <div className="row align-items-center">
                        <div className="col-icon">
                            <div className="icon-big text-center icon-danger bubble-shadow-small">
                            <i className="fas fa-pause-circle" /> 
                            </div>
                        </div>
                        <div className="col col-stats ms-3 ms-sm-0">
                            <div className="numbers">
                            <p className="card-category">In-Active Batches</p>
                            <h4 className="card-title">{data?.inactiveBatches}</h4>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="card card-round">
                        <div className="card-header">
                            <div className="card-head-row">
                            <div className="card-title">Batch Statistics</div>
                            {/* <div className="card-tools">
                                <a
                                href="#"
                                className="btn btn-label-success btn-round btn-sm me-2"
                                >
                                <span className="btn-label">
                                    <i className="fa fa-pencil" />
                                </span>
                                Export
                                </a>
                                <a href="#" className="btn btn-label-info btn-round btn-sm">
                                <span className="btn-label">
                                    <i className="fa fa-print" />
                                </span>
                                Print
                                </a>
                            </div> */}
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="chart-container" style={{ minHeight: 375 }}>
                            <div>
                                <BatchGraph avgMarks={data?.activeBatchDetails}/>
                            </div>
                           
                            </div>
                            <div id="myChartLegend" />
                        </div>
                        </div>
                    </div>
                </div> 
              
            </>
            )}
          </div>
        </div>
      </>
    )
}